import { Workbox } from 'workbox-window'

import { serviceWorkerUpdateStore } from 'components/ServiceWorkerUpdateModal/ServiceWorkerUpdateStore'
import { isIFrame } from 'utils/isIFrame'
import { pwaMediaQueryMatch } from 'utils/isPwa'
import { registerMainSession, unregisterMainSession } from 'utils/pwaSessionManager/client'
import { setWorkboxInstance } from './workboxInstance'

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return
  }

  // Remove the ff, once we have released the service worker for everyone
  if (localStorage.getItem('canInstallServiceWorker') !== 'yes') {
    navigator.serviceWorker.getRegistration('/service-worker.js').then((reg) => reg?.unregister())
    return
  }
  const wb = new Workbox('/service-worker.js')
  setWorkboxInstance(wb)

  if (!isIFrame()) {
    if (pwaMediaQueryMatch.matches) {
      registerMainSession()
    }
    if (pwaMediaQueryMatch.addEventListener) {
      pwaMediaQueryMatch.addEventListener('change', (ev) => {
        if (!ev.matches) {
          unregisterMainSession()
          return
        }
        registerMainSession()
      })
    }
  }

  wb.addEventListener('installed', (event) => {
    /**
     * We have the condition - event.isUpdate because we don't want to show
     * this message on the very first service worker installation,
     * only on the updated
     */
    if (event.isUpdate) {
      serviceWorkerUpdateStore.prompt()
    }
  })
  wb.register()
}
